
import '../node_modules/owl.carousel/dist/owl.carousel'; // Gestion des popup
import './flexible-content/bloc-actu-stage'; // BlocActu stage
import './flexible-content/bloc-onglets'; // BlocActu Onglet de la home 
import './flexible-content/bloc-combien-ca-coute'; // Bloc Tarif / Crédit impot 50%
import './flexible-content/bloc-video';
import './flexible-content/bloc_image_video_texte_cta';

jQuery(function() {

    /**  Slider des blocs d'offres standards */
    if (jQuery("#section-blocs-offres").length>0) {
        if (jQuery(window).width()>= 768) {
                        // Initialisation du carousel des bloc offres
            // uniquement pour les écrans > à 768px                        
            jQuery('#section-blocs-offres .owl-carousel').owlCarousel({
                loop:false,              
                dots: true,                
                stagePadding: 50,
                margin: 20,
                responsive: {
                    768: {
                        items:2,
                        stagePadding: 50,
                        margin: 20,
                    },
                    1024: {
                        items:2,
                        stagePadding: 100,
                        margin: 20,
                    },
                    1200: {
                        items:3
                    }                    
                }               
            });
        }
        
        // Affiche les blocs qui onté été masqués
        jQuery("#section-blocs-offres .owl-carousel .item").removeClass("hide");
        
    }

    /**  Slider des blocs d'offres secondaires */
    if (jQuery("#section-blocs-offres-secondaires").length>0) {
        if (jQuery(window).width()>= 768) {
            // Initialisation du carousel des bloc offres
            // uniquement pour les écrans > à 768px                        
            jQuery('#section-blocs-offres-secondaires .owl-carousel').owlCarousel({
                loop:false,              
                dots: true,                
                stagePadding: 50,
                margin: 20,
                responsive: {
                    768: {
                        items:2,
                        stagePadding: 50,
                        margin: 20,
                    },
                    1024: {
                        items:2,
                        stagePadding: 100,
                        margin: 20,
                    },
                    1200: {
                        items:3
                    }                    
                }               
            });
        }
        
        // Affiche les blocs qui onté été masqués
        jQuery("#section-blocs-offres-secondaires .owl-carousel .item").removeClass("hide");
        
    }
           
});